import React from 'react'

import ActivateIntegrationButtonSection from 'components/ActivateIntegrationButtonSection'

/**
 * @typedef {object} IntegrationSetting
 * @property {string} name
 * @property {boolean} isActive
 *
 * @param {object} props
 * @param {(IntegrationSetting) => void} props.onChange
 * @param {boolean} props.loading
 * @param {boolean} props.isAuthenticated
 * @param {boolean} props.isIntegrationActive
 */
export default function PullTicketIntegration({
  onChange,
  loading,
  isAuthenticated,
  isIntegrationActive,
}) {
  function activateIntegration() {
    onChange({
      name: 'pull_ticket',
      isActive: true,
    })
  }

  function deactivateIntegration() {
    onChange({
      name: 'pull_ticket',
      isActive: false,
    })
  }

  return (
    <React.Fragment>
      <div className="mb-4">
        <p>
          Each time your customer provides a rating, we'll collect conversation, user, and teammate
          details associated with the Intercom conversation.
        </p>
        <p>
          <em>
            All information gathered through the API will override fields sent through URL
            parameters.
          </em>
        </p>
        <a
          href="https://help.simplesat.io/en/articles/5230032-intercom-integration#h_c813d8f860"
          target="_blank"
          rel="noreferrer"
        >
          <i className="icon far fa-book" />
          Learn more about Intercom sync conversation details
        </a>
      </div>

      <ActivateIntegrationButtonSection
        activateIntegration={activateIntegration}
        deactivateIntegration={deactivateIntegration}
        loading={loading}
        isAuthenticated={isAuthenticated}
        isIntegrationActive={isIntegrationActive}
        integrationType="Intercom"
      />
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntercomInAppPublish/PullTicketIntegration.js